// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_RiE","cls2":"VideoResults-cls2_jsH VideoResults-cls1_RiE"};